import { render, staticRenderFns } from "./PendingTasks.vue?vue&type=template&id=7b884f65"
import script from "./PendingTasks.vue?vue&type=script&lang=js"
export * from "./PendingTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports